import api from "../api"

export class NotificationService {
    static pathBase = "/users/notifications/"

    static async register(body: PushSubscription) {
        return api.post(this.pathBase + "device", body)
    }

    static async delete(id: string) {
        return api.delete(this.pathBase + `device/${id}`)
    }
}